import { Backdrop, Card, CardContent, CardHeader, Divider, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
// import { text } from '../../languages/index'
import { connect } from 'react-redux';
import { productHistoryRequest } from '../store/actions';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1150
  },
  methodCell: {
    width: 100
  },
  statusCell: {
    width: 64
  },
  baslik: {
    padding: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function Tarihce({ className, UrunData, productHistoryReducer, productHistoryRequest }) {
  const classes = useStyles();

  useEffect(() => {
    productHistoryRequest(UrunData);
    // eslint-disable-next-line
  }, [])

  return (
    <div
      className={clsx(classes.root, className)}
    >
      <Card>
        <CardHeader title="Ürün Tarihçe" />
        <Divider />
        <CardContent className={classes.content}>
          {
            productHistoryReducer.loading ?
              <Backdrop className={classes.backdrop} open={productHistoryReducer.loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
              : <div></div>
          }
          <List className={classes.root}>
            {productHistoryReducer.data.map(log => (
              <div key={log.SIRA}>
                <ListItem alignItems="flex-start">
                  <ListItemAvatar>
                    <div>
                      <Typography
                        component="span"
                        variant="h3"
                        className={classes.inline}
                        color="textPrimary">
                        {log.GUN}
                      </Typography>
                      <br />
                      <Typography
                        component="span"
                        variant="subtitle1"
                        className={classes.inline}
                        color="textPrimary">{log.AY}
                      </Typography>
                      <br />
                      <Typography
                        component="span"
                        variant="subtitle1"
                        className={classes.inline}
                        color="textPrimary">{log.YIL}
                      </Typography>
                      <br></br>
                      <Typography
                        component="span"
                        variant="caption"
                        className={classes.inline}
                        color="textPrimary">{log.SAAT}
                      </Typography>
                    </div>
                  </ListItemAvatar>
                  <ListItemText
                    primary={log.BASVURU_NEDENI}
                    secondary={
                      <React.Fragment>
                        <Typography
                          component="span"
                          variant="body2"
                          className={classes.inline}
                          color="textPrimary"
                        >
                          {log.FIS_NO}
                          <br></br>
                          {log.DURUM}
                        </Typography>
                        <br></br>
                        Hizmet: {log.HIZMETLER}
                        <br></br>
                        İşçilik: {log.ISCILIKLER}
                        <br></br>
                        Malzeme: {log.MALZEMELER}
                        <br></br>
                        SN: {log.SONUC_NOTU}
                        <br></br>
                        Bayi: {log.BAYI}

                      </React.Fragment>
                    }
                  />

                </ListItem>

                <Divider variant="inset" component="li" />
              </div>
            ))}
          </List>
        </CardContent>
      </Card>
    </div>
  );
}

Tarihce.propTypes = {
  className: PropTypes.string
};

export default connect(
  (state) => ({
    productHistoryReducer: state.productHistoryReducer,
  }),
  { productHistoryRequest }
)(Tarihce);
